// Modules
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { ButtonCTA } from '@global/components/UI Elements/ButtonCTA';

// Utils
import {
  Pages,
  SUBSCRIPTION_SITE_NAMES,
  CUSTOMER_PORTAL_URL,
} from '@global/App/constants/constants';
import analytic from '@global/utils/AdobeAnalytics';
import { SiteConfig } from '@global/utils/SiteConfig';
import { prefixPath } from '@src/global/localization/services';

export const SubscriptionNotificationBody: FC<{
  doLogout: () => void;
  email?: string;
}> = ({ doLogout, email }) => {
  const { t, i18n } = useTranslation('', {
    keyPrefix: 'checkout.step1.subscriptionExist',
  });

  const { siteId, isSpectraBase, isAigateway, isB2CSite } =
    SiteConfig.getConfig();
  const siteName = SUBSCRIPTION_SITE_NAMES[siteId];

  const goToSubscription = useCallback(() => {
    analytic.dataLayerBtnTracker({
      btnType: 'cta',
      btnName: t('ctaGreen'),
    });
    if (isB2CSite) {
      location.replace(CUSTOMER_PORTAL_URL);
    } else {
      location.replace(prefixPath(Pages.SUBSCRIPTION_DETAILS, i18n.language));
    }
  }, [t, i18n.language, isB2CSite]);

  const changeAccount = useCallback(() => {
    analytic.dataLayerBtnTracker({
      btnType: 'cta',
      btnName: t('ctaWhite'),
    });
    analytic.dataLayerForm({
      formName: 'SubscriptionExistModal',
      formEvent: 'LogoutSuccess',
    });
    doLogout();
  }, []);

  return (
    <>
      <div className="modal__content">
        {t('text1')}
        <strong className={'bold'}>{email} </strong>
        {t('text2', { siteName })}
      </div>

      <ButtonCTA
        variant="primary"
        className="modal__action-btn"
        onClick={goToSubscription}
        tabIndex={1}
      >
        {t('ctaGreen')}
      </ButtonCTA>

      {/* Connect has no logout API and can't redirect back, so hide for Connect-auth sites */}
      {!isSpectraBase && !isAigateway && (
        <div style={{ textAlign: 'center' }}>
          <button
            className="modal__back-btn"
            onClick={changeAccount}
            tabIndex={2}
          >
            {t('ctaWhite')}
          </button>
        </div>
      )}
    </>
  );
};
